import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DepartamentosFilters } from '../../models/departamento-filters-state.models';

@Injectable({
  providedIn: 'root',
})

export class DepartamentoFiltersService {

  currentFilters: DepartamentosFilters = {
    departamento: '',
    preco: '',
    ordenar: 'A - Z',
    searchFormArray: ''
  };
  filters$$ = new BehaviorSubject<DepartamentosFilters>(this.currentFilters);

  currentDepartamento: string = '';
}
